<template>
    <div>
      <div class="row columns">
        <div class="large-10 large-offset-1">
          <table>
            <thead class="roster">
            <tr>
              <th width="100"></th>
              <th width="25">Calculé</th>
              <th width="100">Modif. </th>
              <th width="25">Total</th>
              <th width="25">Trésor Supplémentaire</th>
              <template v-if="mode === 'write'">
                <th width="10"></th>
                <th width="10"></th>
              </template>
            </tr>
            </thead>
            <tbody class="">
            <tr>
              <td>nombre de saison jouées: </td>
              <td>{{seasonBreakInfos.played_seasons}}</td>
              <td>{{played_season_offset}}</td>
              <td>{{seasonBreakInfos.played_seasons + played_season_offset}}</td>
              <td>-</td>
              <template v-if="mode === 'write' ">
                <td class="left-button">
                  <button class="row_button" @click="played_season_offset++">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <button class="row_button" @click="played_season_offset--">
                    <i class="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </td>
              </template>
            </tr>
            <tr v-if="mode==='read'">
              <td>Evolution de la popularité: </td>
              <td>{{seasonBreakInfos.fan_factor_adjustment}} ({{seasonBreakInfos.fan_factor_roll_1}}, {{seasonBreakInfos.fan_factor_roll_2}})</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <template v-if="mode === 'write'">
                <td></td>
                <td></td>
              </template>
            </tr>
            <tr>
              <td>nombre total d'éliminations: </td>
              <td>{{seasonBreakInfos.total_casualties}}</td>
              <td>{{cas_offset}}</td>
              <td>{{seasonBreakInfos.total_casualties + cas_offset}}</td>
              <td>{{(seasonBreakInfos.total_casualties + cas_offset)* 5}}k </td>
              <template v-if="mode === 'write' ">
                <td class="left-button">
                  <button class="row_button" @click="cas_offset++">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <button class="row_button" @click="cas_offset--">
                    <i class="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </td>
              </template>
            </tr>
            <tr>
              <td>nombre total de touchdowns: </td>
              <td>{{seasonBreakInfos.total_td}}</td>
              <td>{{td_offset}}</td>
              <td>{{seasonBreakInfos.total_td + td_offset}}</td>
              <td>{{(seasonBreakInfos.total_td + td_offset) * 5}}k </td>
              <template v-if="mode === 'write' ">
                <td class="left-button">
                  <button class="row_button" @click="td_offset++">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <button class="row_button" @click="td_offset--">
                    <i class="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </td>
              </template>
            </tr>
            <tr>
              <td>nombre total de match joués cette saison: </td>
              <td>{{seasonBreakInfos.played_matches}}</td>
              <td>{{played_matches_offset}}</td>
              <td>{{seasonBreakInfos.played_matches + played_matches_offset}}</td>
              <td>{{(seasonBreakInfos.played_matches + played_matches_offset)* 10}}k</td>
              <template v-if="mode === 'write' ">
                <td class="left-button">
                  <button class="row_button" @click="played_matches_offset++">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </td>
                <td>
                  <button class="row_button" @click="played_matches_offset--">
                    <i class="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </td>
              </template>
            </tr>
            <tr v-if="mode==='read'">
              <td>Trésor actuel: </td>
              <td>{{team.treasury}} kpO</td>
              <template v-if="mode === 'write'">
                <td></td>
                <td></td>
              </template>
            </tr>
            <tr v-if="mode==='read'">
              <td>Budget de redémmarrage: </td>
              <td>{{seasonBreakInfos.restart_budget}} kpO</td>
              <template v-if="mode === 'write'">
                <td></td>
                <td></td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
import spinner from '../../../common/spinner.vue'
import messageModal from '../../../common/message-modal.vue'
import playerUpgradeModal from '../../../common/player-upgrade-modal.vue'
import playerSBILine from './player-season-break-line'

export default {
  name: 'season-break-team-infos',
  components: {
    spinner,
    playerUpgradeModal,
    messageModal,
    playerSBILine
  },
  props: {
    mode: '',
    seasonBreakInfos: {},
    team: {}
  },
  data () {
    return {
      played_season_offset: this.seasonBreakInfos.custom.additional_played_seasons,
      played_matches_offset: this.seasonBreakInfos.custom.additional_played_matches,
      cas_offset: this.seasonBreakInfos.custom.additional_casualties,
      td_offset: this.seasonBreakInfos.custom.additional_td
    }
  },
  computed: {
  },
  methods: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 600;
    font-size:0.7rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.6rem;
}
</style>



// WEBPACK FOOTER //
// team-season-break-infos.vue?9badd9b2